import { Link } from "react-router-dom";
import { ArrowUpRight, Users } from "lucide-react";
import { IMAGES, waLink } from "@/data/content";
import { FadeUp, Overline } from "./Reveal";

export const Community = () => (
  <section id="community" data-testid="community-section" className="mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-36">
    <div className="grid items-center gap-14 lg:grid-cols-2">
      <FadeUp>
        <div className="relative">
          <div className="overflow-hidden">
            <img
              src={IMAGES.community}
              alt="JÀWÀ community gathering"
              loading="lazy"
              className="aspect-[4/5] w-full object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -right-4 border border-jawa-turquoise/60 bg-jawa-espresso px-7 py-5 sm:-right-8">
            <p className="font-serif text-3xl text-jawa-turquoise">Live</p>
            <p className="mt-1 text-[10px] uppercase tracking-[0.3em] text-jawa-ivory/70">Membership open</p>
          </div>
        </div>
      </FadeUp>

      <FadeUp delay={0.1}>
        <Overline>The JÀWÀ Community</Overline>
        <h2 className="mt-4 font-serif text-4xl font-medium tracking-tight text-jawa-espresso sm:text-5xl">
          A private circle for people coming home.
        </h2>
        <p className="mt-6 max-w-lg text-base leading-relaxed text-jawa-espresso/70">
          Every paid membership includes the JÀWÀ WhatsApp Community — ask questions, share useful
          information and connect with returnees, tourists, investors and expats on the same journey.
          Members also receive priority VIP access to eligible JÀWÀ events and exclusive member pricing
          on selected services.
        </p>
        <div className="mt-10 flex flex-wrap items-center gap-4">
          <Link
            to="/memberships"
            data-testid="community-membership-button"
            className="inline-flex items-center gap-2 bg-jawa-coral px-8 py-4 text-xs font-semibold uppercase tracking-[0.25em] text-white transition-colors duration-300 hover:bg-jawa-espresso"
          >
            <Users className="h-4 w-4" /> Explore Memberships
          </Link>
          <a
            href={waLink("Hello JÀWÀ — I'd like to know more about the community.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="community-whatsapp-button"
            className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.25em] text-jawa-turquoise transition-colors hover:text-jawa-espresso"
          >
            Ask a question <ArrowUpRight className="h-4 w-4" />
          </a>
          <Link
            to="/community"
            data-testid="community-page-link"
            className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.25em] text-jawa-espresso/60 transition-colors hover:text-jawa-coral"
          >
            Visit the Community <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </FadeUp>
    </div>
  </section>
);
